import {
  knToEuroConverter,
  euroToKnConverter,
  activeCurrencyByDate,
} from "../../Helpers/CurrencyConverter";
import { partnerService } from "../partner.service.js";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake?.vfs;


export const convertToPdf = {
  handlePrint,
  sendPdfToMail,
  sendPdfToPartnerMail,
};

async function handlePrint(
  invoiceDetails,
  invoiceDetailsItems,
  invoiceDetailsPayments,
  invoiceDetailsTaxes,
  translator,
  base64QR
) {
  console.log("Idp", invoiceDetailsPayments);
  var paymentId = invoiceDetailsPayments[0].paymentMethodId;
  var year = new Date(invoiceDetails.issued).getFullYear();
  let dataArrayPdf = [];
  var dataRowHeader = [];
  let taxData = [];
  let taxDataHeader = [];
  console.log("Items", invoiceDetailsItems);
  console.log("det", invoiceDetails);
  dataRowHeader.push(
    {
      text: translator("Naziv"),
      fontSize: 10,
      alignment: "left",
      bold: true,
    },
    {
      text: translator("Cijena"),
      fontSize: 10,
      alignment: "right",
      bold: true,
    },
    {
      text: translator("Količina"),
      fontSize: 10,
      alignment: "right",
      bold: true,
    },
    {
      text: translator("Popust"),
      fontSize: 10,
      alignment: "right",
      bold: true,
    },
    {
      text: translator("Iznos"),
      fontSize: 10,
      alignment: "right",
      bold: true,
    }
  );

  taxDataHeader.push(
    {
      text: translator("Stopa(%)"),
      fontSize: 10,
      alignment: "left",
      bold: true,
    },
    {
      text: translator("Osnovica"),
      fontSize: 10,
      alignment: "right",
      bold: true,
    },
    {
      text: translator("Iznos"),
      fontSize: 10,
      alignment: "right",
      bold: true,
    }
  );

  //items
  dataArrayPdf.push(dataRowHeader);
  invoiceDetailsItems.forEach(function (sourceRow) {
    var dataRow = [];
    dataRow.push({
      text: sourceRow.productName,
      fontSize: 10,
      alignment: "left",
    });
    dataRow.push({
      text: new Intl.NumberFormat("hr", {
        style: "currency",
        currency: activeCurrencyByDate(invoiceDetails.issued),
      }).format(Number(sourceRow.price)),
      fontSize: 10,
      alignment: "right",
    });
    dataRow.push({
      text: `${sourceRow.quantity} ${sourceRow.unitOfMeasureName}`,
      fontSize: 10,
      alignment: "right",
    });

    dataRow.push({
      text: `${sourceRow.discount}%`,
      fontSize: 10,
      alignment: "right",
    });
    dataRow.push({
      text: new Intl.NumberFormat("hr", {
        style: "currency",
        currency: activeCurrencyByDate(invoiceDetails.issued),
      }).format(Number(sourceRow.totalValue)),
      fontSize: 10,
      alignment: "right",
    });

    dataArrayPdf.push(dataRow);
  });

  //taxes
  taxData.push(taxDataHeader);
  invoiceDetailsTaxes.forEach(function (sourceRow) {
    if (1 == 1) {
      var dataRow = [];
      dataRow.push({
        text:
          sourceRow.taxRateId != null
            ? `PDV: ${sourceRow.taxRate}`
            : `PP: ${sourceRow.pp}`,
        fontSize: 10,
        alignment: "left",
      });

      dataRow.push({
        text: new Intl.NumberFormat("hr", {
          style: "currency",
          currency: activeCurrencyByDate(invoiceDetails.issued),
        }).format(Number(sourceRow.groupNetValue)),
        fontSize: 10,
        alignment: "right",
      });
      dataRow.push({
        text:
          sourceRow.taxRateId != null
            ? new Intl.NumberFormat("hr-HR", {
                style: "currency",
                currency: activeCurrencyByDate(invoiceDetails.issued),
                minimumFractionDigits: 2,
              }).format(sourceRow.groupTaxValue)
            : new Intl.NumberFormat("hr-HR", {
                style: "currency",
                currency: activeCurrencyByDate(invoiceDetails.issued),
                minimumFractionDigits: 2,
              }).format(sourceRow.groupPpvalue),
        fontSize: 10,
        alignment: "right",
      });
      taxData.push(dataRow);
    }
  });

  let withoutTax = invoiceDetailsItems
    .filter((e) => e.taxRateId === 0)
    .reduce(function (a, b) {
      return Number(a) + Number(b.totalValue);
    }, 0);

  if (withoutTax > 0) {
    var dataRow = [];
    dataRow.push({
      text: "Bez poreza",
      fontSize: 10,
      alignment: "left",
    });
    dataRow.push({
      text: " ",
      fontSize: 10,
      alignment: "right",
    });
    dataRow.push({
      text: new Intl.NumberFormat("hr-HR", {
        style: "currency",
        currency: activeCurrencyByDate(invoiceDetails.issued),
        minimumFractionDigits: 2,
      }).format(withoutTax),
      fontSize: 10,
      alignment: "right",
    });
    taxData.push(dataRow);
  }
  let pn = Number(
    invoiceDetailsItems.reduce(function (a, b) {
      return Number(a) + Number(b.pn) * b.quantity;
    }, 0)
  );

  let dd = {
    info: {
      title: "Detalji računa",
      author: "Premium fiskalna blagajna",
      subject: "Detalji računa",
    },
    // a string or { width: number, height: number }
    pageSize: "A4",
    // by default we use portrait, you can change it to landscape if you wish
    pageOrientation: "portrait",
    // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
    pageMargins: [20, 165, 15, 50],
    header: [
      {
        columns: [
          {
            text: [
              {
                text: `${invoiceDetails.tenantName} \n`,
                fontSize: 18,
                bold: true,
                alignment: "left",
                letterSpacing: 15,
                lineHeight: 1,
                marginTop: 30,
                marginLeft: 10,
              },
              {
                text: `${invoiceDetails.address}\n`,
                fontSize: 12,
                bold: true,
                alignment: "left",
                letterSpacing: 12,
                lineHeight: 1,
                marginTop: 20,
              },
              {
                text: `${invoiceDetails.tenantCity}\n`,
                fontSize: 12,
                bold: true,
                alignment: "left",
                letterSpacing: 12,
                lineHeight: 1,
                marginTop: 20,
              },
              {
                text: `OIB: ${invoiceDetails.tenantOib} \n`,
                fontSize: 12,
                bold: true,
                alignment: "left",
                letterSpacing: 12,
                lineHeight: 1,
                marginTop: 20,
              },
              {
                text: `IBAN: ${invoiceDetails.iban.toUpperCase()} \n`,
                fontSize: 12,
                bold: true,
                alignment: "left",
                letterSpacing: 12,
                lineHeight: 1,
                marginTop: 20,
              },
              {
                text: "Vlasnik: ",
                fontSize: 12,
                bold: true,
                alignment: "left",
                letterSpacing: 12,
                lineHeight: 1,
                marginTop: 20,
              },
              {
                text: `${invoiceDetails.owner}\n`,
                fontSize: 12,
                bold: true,
                alignment: "left",
                letterSpacing: 12,
                lineHeight: 1,
                marginTop: 20,
              },
            ],
            fontSize: 12,
            marginRight: 20,
            marginLeft: 20,
            marginTop: 25,
            bold: false,
            alignment: "right",
            color: "#333",
            height: 60,
            lineHeight: 0.7,
            letterSpacing: 50,
          },
          invoiceDetails.tenantLogo
            ? {
                image: invoiceDetails.tenantLogo
                  ? `data:image/png;base64,${invoiceDetails.tenantLogo}`
                  : "data:image/png;base64",
                width: 250,
              }
            : {},
        ],
      },
    ],

    content: [
      {
        columns: [
          {
            text: `${invoiceDetails.storeName}\n${invoiceDetails.storeAddress}\n${invoiceDetails.storeCity}\nHrvatska\n\n`,
            marginRight: 20,
          },
          {
            text: invoiceDetails.partnerGuid
              ? `Kupac: ${invoiceDetails.partnerName}\n  ${invoiceDetails.partnerOib}\n ${invoiceDetails.partnerAddress}\n ${invoiceDetails.partnerCity}\n\n`
              : "",
          },
        ],
      },

      {
        text: `Datum računa: ${new Intl.DateTimeFormat("hr", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          timeZone: "Europe/Zagreb",
        }).format(new Date(invoiceDetails.issued))}\n`,
        fontSize: 11,
      },

      {
        text: `Vrijeme računa : ${new Intl.DateTimeFormat("hr", {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: false,
          timeZone: "Europe/Zagreb",
        }).format(new Date(invoiceDetails.issued))}\n`,
        fontSize: 11,
      },

      {
        text: `Način plaćanja : ${
          invoiceDetailsPayments.reduce(function (a, b) {
            return Number(a) + Number(b.paidValue);
          }, 0) > 0
            ? invoiceDetailsPayments.filter((e) => Number(e.paidValue) > 0)[0]
                .paymentMethodName
            : `${invoiceDetails.paymentMethodName} / Storno`
        }`,
        fontSize: 11,
      },
      { text: `Blagajnik : ${invoiceDetails.userPrintName}\n\n`, fontSize: 11 },
      {
        text: `Račun: ${invoiceDetails.documentNumber}/${invoiceDetails.storeTag}/${invoiceDetails.posTag}\n\n`,
        bold: true,
        fontSize: 18,
      },
      {
        table: {
          headerRows: 1,
          widths: ["50%", "*", "*", "auto", "*"],
          body: dataArrayPdf,
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === 0 || i === 1 || i === node.table.body.length ? 1 : 0.1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 0;
          },
          hLineColor: function (i, node) {
            return i === 0 || i === 1 || i === node.table.body.length
              ? "black"
              : "#f1f1f1";
          },
          vLineColor: function (i, node) {
            return i === 0 || i === node.table.widths.length
              ? "white"
              : "white";
          },
        },
      },

      {
        columns: [
          {
            text: "Ukupno :",
            marginTop: 15,
            marginBottom: 0,
            width: "*",
            bold: false,
            fontSize: 12,
          },
          {
            text: new Intl.NumberFormat("hr", {
              style: "currency",
              currency: activeCurrencyByDate(invoiceDetails.issued),
            }).format(Number(invoiceDetails.totalValue)),
            marginTop: 15,
            marginBottom: 0,
            width: "*",
            alignment: "right",
            bold: false,
            fontSize: 12,
          },
        ],
      },
      {
        columns: [
          {
            text: "Popust :",
            marginTop: 0,
            marginBottom: 0,
            width: "*",
            bold: false,
            fontSize: 12,
          },
          {
            text: new Intl.NumberFormat("hr", {
              style: "currency",
              currency: activeCurrencyByDate(invoiceDetails.issued),
            }).format(Number(invoiceDetails.discountValue)),
            marginTop: 0,
            marginBottom: 0,
            width: "*",
            alignment: "right",
            bold: false,
            fontSize: 12,
          },
        ],
      },
      {
        columns: [
          {
            text: "ZA PLATITI :",
            marginTop: 5,
            marginBottom: 5,
            width: "*",
            bold: true,
            fontSize: 15,
          },
          {
            text: new Intl.NumberFormat("hr", {
              style: "currency",
              currency: activeCurrencyByDate(invoiceDetails.issued),
            }).format(Number(invoiceDetails.payValue)),
            marginTop: 5,
            marginBottom: 0,
            width: "*",
            alignment: "right",
            bold: true,
            fontSize: 15,
          },
        ],
      },

      invoiceDetails.isTax ||
      invoiceDetailsTaxes.filter((e) => e.taxRateId === 4).length === 0
        ? `Rekapitulacija poreza \n`
        : "",
      invoiceDetails.inTax ||
      invoiceDetailsTaxes.filter((e) => e.taxRateId === 4).length === 0
        ? {
            table: {
              headerRows: 1,
              widths: [100, 100, 100],
              body: taxData,
            },
            layout: {
              hLineWidth: function (i, node) {
                return i === 0 || i === 1 || i === node.table.body.length
                  ? 1
                  : 0.1;
              },
              vLineWidth: function (i, node) {
                return i === 0 || i === node.table.widths.length ? 1 : 0;
              },
              hLineColor: function (i, node) {
                return i === 0 || i === 1 || i === node.table.body.length
                  ? "black"
                  : "f1f1f1";
              },
              vLineColor: function (i, node) {
                return i === 0 || i === node.table.widths.length
                  ? "white"
                  : "white";
              },
            },
          }
        : null,
      pn > 0
        ? {
            table: {
              headerRows: 1,
              widths: [100, 100, 100],
              body: [
                [
                  {
                    text: "Povratna naknada:",
                    fontSize: 10,
                    alignment: "left",
                  },
                  {
                    text: "",
                    fontSize: 10,
                    alignment: "left",
                  },
                  {
                    text: new Intl.NumberFormat("hr", {
                      style: "currency",
                      currency: activeCurrencyByDate(invoiceDetails.issued),
                    }).format(
                      Number(
                        invoiceDetailsItems.reduce(function (a, b) {
                          return Number(a) + Number(b.pn) * b.quantity;
                        }, 0)
                      )
                    ),
                    fontSize: 10,
                    alignment: "right",
                  },
                ],
              ],
            },
            layout: {
              hLineWidth: function (i, node) {
                return i === 0 || i === 1 || i === node.table.body.length
                  ? 0.5
                  : 0;
              },
              vLineWidth: function (i, node) {
                return i === 0 || i === node.table.widths.length ? 1 : 0;
              },
              hLineColor: function (i, node) {
                return i === 0 || i === node.table.body.length
                  ? "black"
                  : "white";
              },
              vLineColor: function (i, node) {
                return i === 0 || i === node.table.widths.length
                  ? "white"
                  : "white";
              },
            },
          }
        : null,
      {
        text:
          invoiceDetails.taxNote 
         
            ? `\n Porezna bilješka: ${invoiceDetails.taxNote} \n`
            : "",
        fontSize: 10,
        marginLeft: 5,
      },
      "",
      {
        text: invoiceDetails.description
          ? `\n ${invoiceDetails.description} \n`
          : "",
        fontSize: 10,
        marginLeft: 5,
      },

      " ",
      paymentId == 4 && year < 2026
        ? null
        : {
            image: base64QR,
            width: 60,
            marginLeft: 0,
            marginTop: 5,
            alignment: "right",
          },
       paymentId == 4 && year < 2026
        ? null
        : {
            text: `\nZKI: ${invoiceDetails.zki}\nJIR: ${invoiceDetails.jir}\n\n\n\n`,
            alignment: "right",
            fontSize: 10,
          },
      {
        text: `${invoiceDetails.footerNote}`,
        alignment: "center",
        fontSize: 11,
      },
    ],
    footer: function (currentPage, pageCount) {
      return {
        table: {
          widths: ["*"],
          body: [
            [
              {
                text:
                  `${translator("InvoiceCashBalancePDF-Page")} ` +
                  currentPage.toString() +
                  " / " +
                  pageCount,
                alignment: "right",
                style: "normalText",
                fontSize: 10,
                margin: [0, 20, 20, 0],
              },
            ],
          ],
        },
        layout: "noBorders",
      };
    },
  };
  pdfMake.createPdf(dd).open();
}
async function sendPdfToPartnerMail(
  invoiceDetails,
  invoiceDetailsItems,
  invoiceDetailsPayments,
  invoiceDetailsTaxes,
  translator,
  base64QR,
  
) {
  console.log("Idp", invoiceDetailsPayments);
  var paymentId = invoiceDetailsPayments[0].paymentMethodId;
  console.log("paymentId", paymentId);
  let year = new Date(invoiceDetails.issued).getFullYear();
  let dataArrayPdf = [];
  var dataRowHeader = [];
  let taxData = [];
  let taxDataHeader = [];
  console.log("Items", invoiceDetailsItems);
  console.log("det", invoiceDetails);
  dataRowHeader.push(
    {
      text: translator("Naziv"),
      fontSize: 10,
      alignment: "left",
      bold: true,
    },
    {
      text: translator("Cijena"),
      fontSize: 10,
      alignment: "right",
      bold: true,
    },
    {
      text: translator("Količina"),
      fontSize: 10,
      alignment: "right",
      bold: true,
    },
    {
      text: translator("Popust"),
      fontSize: 10,
      alignment: "right",
      bold: true,
    },
    {
      text: translator("Iznos"),
      fontSize: 10,
      alignment: "right",
      bold: true,
    }
  );

  taxDataHeader.push(
    {
      text: translator("Stopa(%)"),
      fontSize: 10,
      alignment: "left",
      bold: true,
    },
    {
      text: translator("Osnovica"),
      fontSize: 10,
      alignment: "right",
      bold: true,
    },
    {
      text: translator("Iznos"),
      fontSize: 10,
      alignment: "right",
      bold: true,
    }
  );

  //items
  dataArrayPdf.push(dataRowHeader);
  invoiceDetailsItems.forEach(function (sourceRow) {
    var dataRow = [];
    dataRow.push({
      text: sourceRow.productName,
      fontSize: 10,
      alignment: "left",
    });
    dataRow.push({
      text: new Intl.NumberFormat("hr", {
        style: "currency",
        currency: activeCurrencyByDate(invoiceDetails.issued),
      }).format(Number(sourceRow.price)),
      fontSize: 10,
      alignment: "right",
    });
    dataRow.push({
      text: `${sourceRow.quantity} ${sourceRow.unitOfMeasureName}`,
      fontSize: 10,
      alignment: "right",
    });

    dataRow.push({
      text: `${sourceRow.discount}%`,
      fontSize: 10,
      alignment: "right",
    });
    dataRow.push({
      text: new Intl.NumberFormat("hr", {
        style: "currency",
        currency: activeCurrencyByDate(invoiceDetails.issued),
      }).format(Number(sourceRow.totalValue)),
      fontSize: 10,
      alignment: "right",
    });

    dataArrayPdf.push(dataRow);
  });

  //taxes
  taxData.push(taxDataHeader);
  invoiceDetailsTaxes.forEach(function (sourceRow) {
    if (1 == 1) {
      var dataRow = [];
      dataRow.push({
        text:
          sourceRow.taxRateId != null
            ? `PDV: ${sourceRow.taxRate}`
            : `PP: ${sourceRow.pp}`,
        fontSize: 10,
        alignment: "left",
      });

      dataRow.push({
        text: new Intl.NumberFormat("hr", {
          style: "currency",
          currency: activeCurrencyByDate(invoiceDetails.issued),
        }).format(Number(sourceRow.groupNetValue)),
        fontSize: 10,
        alignment: "right",
      });
      dataRow.push({
        text:
          sourceRow.taxRateId != null
            ? new Intl.NumberFormat("hr-HR", {
                style: "currency",
                currency: activeCurrencyByDate(invoiceDetails.issued),
                minimumFractionDigits: 2,
              }).format(sourceRow.groupTaxValue)
            : new Intl.NumberFormat("hr-HR", {
                style: "currency",
                currency: activeCurrencyByDate(invoiceDetails.issued),
                minimumFractionDigits: 2,
              }).format(sourceRow.groupPpvalue),
        fontSize: 10,
        alignment: "right",
      });
      taxData.push(dataRow);
    }
  });

  let withoutTax = invoiceDetailsItems
    .filter((e) => e.taxRateId === 0)
    .reduce(function (a, b) {
      return Number(a) + Number(b.totalValue);
    }, 0);

  if (withoutTax > 0) {
    var dataRow = [];
    dataRow.push({
      text: "Bez poreza",
      fontSize: 10,
      alignment: "left",
    });
    dataRow.push({
      text: " ",
      fontSize: 10,
      alignment: "right",
    });
    dataRow.push({
      text: new Intl.NumberFormat("hr-HR", {
        style: "currency",
        currency: activeCurrencyByDate(invoiceDetails.issued),
        minimumFractionDigits: 2,
      }).format(withoutTax),
      fontSize: 10,
      alignment: "right",
    });
    taxData.push(dataRow);
  }
  let pn = Number(
    invoiceDetailsItems.reduce(function (a, b) {
      return Number(a) + Number(b.pn) * b.quantity;
    }, 0)
  );

  let dd = {
    info: {
      title: "Detalji računa",
      author: "Premium fiskalna blagajna",
      subject: "Detalji računa",
    },
    // a string or { width: number, height: number }
    pageSize: "A4",
    // by default we use portrait, you can change it to landscape if you wish
    pageOrientation: "portrait",
    // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
    pageMargins: [20, 165, 15, 50],
    header: [
      {
        columns: [
          {
            text: [
              {
                text: `${invoiceDetails.tenantName} \n`,
                fontSize: 18,
                bold: true,
                alignment: "left",
                letterSpacing: 15,
                lineHeight: 1,
                marginTop: 30,
                marginLeft: 10,
              },
              {
                text: `${invoiceDetails.address}\n`,
                fontSize: 12,
                bold: true,
                alignment: "left",
                letterSpacing: 12,
                lineHeight: 1,
                marginTop: 20,
              },
              {
                text: `${invoiceDetails.tenantCity}\n`,
                fontSize: 12,
                bold: true,
                alignment: "left",
                letterSpacing: 12,
                lineHeight: 1,
                marginTop: 20,
              },
              {
                text: `OIB: ${invoiceDetails.tenantOib} \n`,
                fontSize: 12,
                bold: true,
                alignment: "left",
                letterSpacing: 12,
                lineHeight: 1,
                marginTop: 20,
              },
              {
                text: `IBAN: ${invoiceDetails.iban} \n`,
                fontSize: 12,
                bold: true,
                alignment: "left",
                letterSpacing: 12,
                lineHeight: 1,
                marginTop: 20,
              },
              {
                text: "Vlasnik: ",
                fontSize: 12,
                bold: true,
                alignment: "left",
                letterSpacing: 12,
                lineHeight: 1,
                marginTop: 20,
              },
              {
                text: `${invoiceDetails.owner}\n`,
                fontSize: 12,
                bold: true,
                alignment: "left",
                letterSpacing: 12,
                lineHeight: 1,
                marginTop: 20,
              },
            ],
            fontSize: 12,
            marginRight: 20,
            marginLeft: 20,
            marginTop: 25,
            bold: false,
            alignment: "right",
            color: "#333",
            height: 60,
            lineHeight: 0.7,
            letterSpacing: 50,
          },
          invoiceDetails.tenantLogo
            ? {
                image: invoiceDetails.tenantLogo
                  ? `data:image/png;base64,${invoiceDetails.tenantLogo}`
                  : "data:image/png;base64",
                width: 250,
              }
            : {},
        ],
      },
    ],

    content: [
      {
        columns: [
          {
            text: `${invoiceDetails.storeName}\n${invoiceDetails.storeAddress}\n${invoiceDetails.storeCity}\nHrvatska\n\n`,
            marginRight: 20,
          },
          {
            text: invoiceDetails.partnerGuid
              ? `Kupac: ${invoiceDetails.partnerName}\n  ${invoiceDetails.partnerOib}\n ${invoiceDetails.partnerAddress}\n ${invoiceDetails.partnerCity}\n\n`
              : "",
          },
        ],
      },

      {
        text: `Datum računa: ${new Intl.DateTimeFormat("hr", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          timeZone: "Europe/Zagreb",
        }).format(new Date(invoiceDetails.issued))}\n`,
        fontSize: 11,
      },

      {
        text: `Vrijeme računa : ${new Intl.DateTimeFormat("hr", {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: false,
          timeZone: "Europe/Zagreb",
        }).format(new Date(invoiceDetails.issued))}\n`,
        fontSize: 11,
      },

      {
        text: `Način plaćanja : ${
          invoiceDetailsPayments.reduce(function (a, b) {
            return Number(a) + Number(b.paidValue);
          }, 0) > 0
            ? invoiceDetailsPayments.filter((e) => Number(e.paidValue) > 0)[0]
                .paymentMethodName
            : `${invoiceDetails.paymentMethodName} / Storno`
        }`,
        fontSize: 11,
      },
      { text: `Blagajnik : ${invoiceDetails.userPrintName}\n\n`, fontSize: 11 },
      {
        text: `Račun: ${invoiceDetails.documentNumber}/${invoiceDetails.storeTag}/${invoiceDetails.posTag}\n\n`,
        bold: true,
        fontSize: 18,
      },
      {
        table: {
          headerRows: 1,
          widths: ["50%", "*", "*", "auto", "*"],
          body: dataArrayPdf,
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === 0 || i === 1 || i === node.table.body.length ? 1 : 0.1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 0;
          },
          hLineColor: function (i, node) {
            return i === 0 || i === 1 || i === node.table.body.length
              ? "black"
              : "#f1f1f1";
          },
          vLineColor: function (i, node) {
            return i === 0 || i === node.table.widths.length
              ? "white"
              : "white";
          },
        },
      },

      {
        columns: [
          {
            text: "Ukupno :",
            marginTop: 15,
            marginBottom: 0,
            width: "*",
            bold: false,
            fontSize: 12,
          },
          {
            text: new Intl.NumberFormat("hr", {
              style: "currency",
              currency: activeCurrencyByDate(invoiceDetails.issued),
            }).format(Number(invoiceDetails.totalValue)),
            marginTop: 15,
            marginBottom: 0,
            width: "*",
            alignment: "right",
            bold: false,
            fontSize: 12,
          },
        ],
      },
      {
        columns: [
          {
            text: "Popust :",
            marginTop: 0,
            marginBottom: 0,
            width: "*",
            bold: false,
            fontSize: 12,
          },
          {
            text: new Intl.NumberFormat("hr", {
              style: "currency",
              currency: activeCurrencyByDate(invoiceDetails.issued),
            }).format(Number(invoiceDetails.discountValue)),
            marginTop: 0,
            marginBottom: 0,
            width: "*",
            alignment: "right",
            bold: false,
            fontSize: 12,
          },
        ],
      },
      {
        columns: [
          {
            text: "ZA PLATITI :",
            marginTop: 5,
            marginBottom: 5,
            width: "*",
            bold: true,
            fontSize: 15,
          },
          {
            text: new Intl.NumberFormat("hr", {
              style: "currency",
              currency: activeCurrencyByDate(invoiceDetails.issued),
            }).format(Number(invoiceDetails.payValue)),
            marginTop: 5,
            marginBottom: 0,
            width: "*",
            alignment: "right",
            bold: true,
            fontSize: 15,
          },
        ],
      },

      invoiceDetails.isTax ||
      invoiceDetailsTaxes.filter((e) => e.taxRateId === 4).length === 0
        ? `Rekapitulacija poreza \n`
        : "",
      invoiceDetails.inTax ||
      invoiceDetailsTaxes.filter((e) => e.taxRateId === 4).length === 0
        ? {
            table: {
              headerRows: 1,
              widths: [100, 100, 100],
              body: taxData,
            },
            layout: {
              hLineWidth: function (i, node) {
                return i === 0 || i === 1 || i === node.table.body.length
                  ? 1
                  : 0.1;
              },
              vLineWidth: function (i, node) {
                return i === 0 || i === node.table.widths.length ? 1 : 0;
              },
              hLineColor: function (i, node) {
                return i === 0 || i === 1 || i === node.table.body.length
                  ? "black"
                  : "f1f1f1";
              },
              vLineColor: function (i, node) {
                return i === 0 || i === node.table.widths.length
                  ? "white"
                  : "white";
              },
            },
          }
        : null,
      pn > 0
        ? {
            table: {
              headerRows: 1,
              widths: [100, 100, 100],
              body: [
                [
                  {
                    text: "Povratna naknada:",
                    fontSize: 10,
                    alignment: "left",
                  },
                  {
                    text: "",
                    fontSize: 10,
                    alignment: "left",
                  },
                  {
                    text: new Intl.NumberFormat("hr", {
                      style: "currency",
                      currency: activeCurrencyByDate(invoiceDetails.issued),
                    }).format(
                      Number(
                        invoiceDetailsItems.reduce(function (a, b) {
                          return Number(a) + Number(b.pn) * b.quantity;
                        }, 0)
                      )
                    ),
                    fontSize: 10,
                    alignment: "right",
                  },
                ],
              ],
            },
            layout: {
              hLineWidth: function (i, node) {
                return i === 0 || i === 1 || i === node.table.body.length
                  ? 0.5
                  : 0;
              },
              vLineWidth: function (i, node) {
                return i === 0 || i === node.table.widths.length ? 1 : 0;
              },
              hLineColor: function (i, node) {
                return i === 0 || i === node.table.body.length
                  ? "black"
                  : "white";
              },
              vLineColor: function (i, node) {
                return i === 0 || i === node.table.widths.length
                  ? "white"
                  : "white";
              },
            },
          }
        : null,
      {
        text:
          invoiceDetails.taxNote
            ? `\n Porezna bilješka: ${invoiceDetails.taxNote} \n`
            : "",
        fontSize: 10,
        marginLeft: 5,
      },
      "",
      {
        text: invoiceDetails.description
          ? `\n ${invoiceDetails.description} \n`
          : "",
        fontSize: 10,
        marginLeft: 5,
      },

      " ",
      paymentId == 4 && year < 2026
        ? null
        : {
            image: base64QR,
            width: 60,
            marginLeft: 0,
            marginTop: 5,
            alignment: "right",
          },
      paymentId == 4 && year < 2026
        ? null
        : {
            text: `\nZKI: ${invoiceDetails.zki}\nJIR: ${invoiceDetails.jir}\n\n\n\n`,
            alignment: "right",
            fontSize: 10,
          },
      {
        text: `${invoiceDetails.footerNote}`,
        alignment: "center",
        fontSize: 11,
      },
    ],
    footer: function (currentPage, pageCount) {
      return {
        table: {
          widths: ["*"],
          body: [
            [
              {
                text:
                  `${translator("InvoiceCashBalancePDF-Page")} ` +
                  currentPage.toString() +
                  " / " +
                  pageCount,
                alignment: "right",
                style: "normalText",
                fontSize: 10,
                margin: [0, 20, 20, 0],
              },
            ],
          ],
        },
        layout: "noBorders",
      };
    },
  };

  const pdfDocGenerator = pdfMake.createPdf(dd);
  pdfDocGenerator.getBase64((data) => {
    partnerService
      .sendToPartner(
        invoiceDetails.partnerGuid,
        data,
        invoiceDetails.InvoiceGuid
      )
      .then((res) => {});
    console.log(data);
  });
}

async function sendPdfToMail(
  invoiceDetails,
  invoiceDetailsItems,
  invoiceDetailsPayments,
  invoiceDetailsTaxes,
  translator,
  base64QR,
  email
) {
  console.log("Idp", invoiceDetailsPayments);
  var paymentId = invoiceDetailsPayments[0].paymentMethodId;
  let year = new Date(invoiceDetails.issued).getFullYear();
  console.log("paymentId", paymentId);
  let dataArrayPdf = [];
  var dataRowHeader = [];
  let taxData = [];
  let taxDataHeader = [];
  console.log("Items", invoiceDetailsItems);
  console.log("det", invoiceDetails);
  dataRowHeader.push(
    {
      text: translator("Naziv"),
      fontSize: 10,
      alignment: "left",
      bold: true,
    },
    {
      text: translator("Cijena"),
      fontSize: 10,
      alignment: "right",
      bold: true,
    },
    {
      text: translator("Količina"),
      fontSize: 10,
      alignment: "right",
      bold: true,
    },
    {
      text: translator("Popust"),
      fontSize: 10,
      alignment: "right",
      bold: true,
    },
    {
      text: translator("Iznos"),
      fontSize: 10,
      alignment: "right",
      bold: true,
    }
  );

  taxDataHeader.push(
    {
      text: translator("Stopa(%)"),
      fontSize: 10,
      alignment: "left",
      bold: true,
    },
    {
      text: translator("Osnovica"),
      fontSize: 10,
      alignment: "right",
      bold: true,
    },
    {
      text: translator("Iznos"),
      fontSize: 10,
      alignment: "right",
      bold: true,
    }
  );

  //items
  dataArrayPdf.push(dataRowHeader);
  invoiceDetailsItems.forEach(function (sourceRow) {
    var dataRow = [];
    dataRow.push({
      text: sourceRow.productName,
      fontSize: 10,
      alignment: "left",
    });
    dataRow.push({
      text: new Intl.NumberFormat("hr", {
        style: "currency",
        currency: activeCurrencyByDate(invoiceDetails.issued),
      }).format(Number(sourceRow.price)),
      fontSize: 10,
      alignment: "right",
    });
    dataRow.push({
      text: `${sourceRow.quantity} ${sourceRow.unitOfMeasureName}`,
      fontSize: 10,
      alignment: "right",
    });

    dataRow.push({
      text: `${sourceRow.discount}%`,
      fontSize: 10,
      alignment: "right",
    });
    dataRow.push({
      text: new Intl.NumberFormat("hr", {
        style: "currency",
        currency: activeCurrencyByDate(invoiceDetails.issued),
      }).format(Number(sourceRow.totalValue)),
      fontSize: 10,
      alignment: "right",
    });

    dataArrayPdf.push(dataRow);
  });

  //taxes
  taxData.push(taxDataHeader);
  invoiceDetailsTaxes.forEach(function (sourceRow) {
    if (1 == 1) {
      var dataRow = [];
      dataRow.push({
        text:
          sourceRow.taxRateId != null
            ? `PDV: ${sourceRow.taxRate}`
            : `PP: ${sourceRow.pp}`,
        fontSize: 10,
        alignment: "left",
      });

      dataRow.push({
        text: new Intl.NumberFormat("hr", {
          style: "currency",
          currency: activeCurrencyByDate(invoiceDetails.issued),
        }).format(Number(sourceRow.groupNetValue)),
        fontSize: 10,
        alignment: "right",
      });
      dataRow.push({
        text:
          sourceRow.taxRateId != null
            ? new Intl.NumberFormat("hr-HR", {
                style: "currency",
                currency: activeCurrencyByDate(invoiceDetails.issued),
                minimumFractionDigits: 2,
              }).format(sourceRow.groupTaxValue)
            : new Intl.NumberFormat("hr-HR", {
                style: "currency",
                currency: activeCurrencyByDate(invoiceDetails.issued),
                minimumFractionDigits: 2,
              }).format(sourceRow.groupPpvalue),
        fontSize: 10,
        alignment: "right",
      });
      taxData.push(dataRow);
    }
  });

  let withoutTax = invoiceDetailsItems
    .filter((e) => e.taxRateId === 0)
    .reduce(function (a, b) {
      return Number(a) + Number(b.totalValue);
    }, 0);

  if (withoutTax > 0) {
    var dataRow = [];
    dataRow.push({
      text: "Bez poreza",
      fontSize: 10,
      alignment: "left",
    });
    dataRow.push({
      text: " ",
      fontSize: 10,
      alignment: "right",
    });
    dataRow.push({
      text: new Intl.NumberFormat("hr-HR", {
        style: "currency",
        currency: activeCurrencyByDate(invoiceDetails.issued),
        minimumFractionDigits: 2,
      }).format(withoutTax),
      fontSize: 10,
      alignment: "right",
    });
    taxData.push(dataRow);
  }
  let pn = Number(
    invoiceDetailsItems.reduce(function (a, b) {
      return Number(a) + Number(b.pn) * b.quantity;
    }, 0)
  );

  let dd = {
    info: {
      title: "Detalji računa",
      author: "Premium fiskalna blagajna",
      subject: "Detalji računa",
    },
    // a string or { width: number, height: number }
    pageSize: "A4",
    // by default we use portrait, you can change it to landscape if you wish
    pageOrientation: "portrait",
    // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
    pageMargins: [20, 165, 15, 50],
    header: [
      {
        columns: [
          {
            text: [
              {
                text: `${invoiceDetails.tenantName} \n`,
                fontSize: 18,
                bold: true,
                alignment: "left",
                letterSpacing: 15,
                lineHeight: 1,
                marginTop: 30,
                marginLeft: 10,
              },
              {
                text: `${invoiceDetails.address}\n`,
                fontSize: 12,
                bold: true,
                alignment: "left",
                letterSpacing: 12,
                lineHeight: 1,
                marginTop: 20,
              },
              {
                text: `${invoiceDetails.tenantCity}\n`,
                fontSize: 12,
                bold: true,
                alignment: "left",
                letterSpacing: 12,
                lineHeight: 1,
                marginTop: 20,
              },
              {
                text: `OIB: ${invoiceDetails.tenantOib} \n`,
                fontSize: 12,
                bold: true,
                alignment: "left",
                letterSpacing: 12,
                lineHeight: 1,
                marginTop: 20,
              },
              {
                text: `IBAN: ${invoiceDetails.iban.toUpperCase()} \n`,
                fontSize: 12,
                bold: true,
                alignment: "left",
                letterSpacing: 12,
                lineHeight: 1,
                marginTop: 20,
              },
              {
                text: "Vlasnik: ",
                fontSize: 12,
                bold: true,
                alignment: "left",
                letterSpacing: 12,
                lineHeight: 1,
                marginTop: 20,
              },
              {
                text: `${invoiceDetails.owner}\n`,
                fontSize: 12,
                bold: true,
                alignment: "left",
                letterSpacing: 12,
                lineHeight: 1,
                marginTop: 20,
              },
            ],
            fontSize: 12,
            marginRight: 20,
            marginLeft: 20,
            marginTop: 25,
            bold: false,
            alignment: "right",
            color: "#333",
            height: 60,
            lineHeight: 0.7,
            letterSpacing: 50,
          },
          invoiceDetails.tenantLogo
            ? {
                image: invoiceDetails.tenantLogo
                  ? `data:image/png;base64,${invoiceDetails.tenantLogo}`
                  : "data:image/png;base64",
                width: 250,
              }
            : {},
        ],
      },
    ],

    content: [
      {
        columns: [
          {
            text: `${invoiceDetails.storeName}\n${invoiceDetails.storeAddress}\n${invoiceDetails.storeCity}\nHrvatska\n\n`,
            marginRight: 20,
          },
          {
            text: invoiceDetails.partnerGuid
              ? `Kupac: ${invoiceDetails.partnerName}\n  ${invoiceDetails.partnerOib}\n ${invoiceDetails.partnerAddress}\n ${invoiceDetails.partnerCity}\n\n`
              : "",
          },
        ],
      },

      {
        text: `Datum računa: ${new Intl.DateTimeFormat("hr", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          timeZone: "Europe/Zagreb",
        }).format(new Date(invoiceDetails.issued))}\n`,
        fontSize: 11,
      },

      {
        text: `Vrijeme računa : ${new Intl.DateTimeFormat("hr", {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: false,
          timeZone: "Europe/Zagreb",
        }).format(new Date(invoiceDetails.issued))}\n`,
        fontSize: 11,
      },

      {
        text: `Način plaćanja : ${
          invoiceDetailsPayments.reduce(function (a, b) {
            return Number(a) + Number(b.paidValue);
          }, 0) > 0
            ? invoiceDetailsPayments.filter((e) => Number(e.paidValue) > 0)[0]
                .paymentMethodName
            : `${invoiceDetails.paymentMethodName} / Storno`
        }`,
        fontSize: 11,
      },
      { text: `Blagajnik : ${invoiceDetails.userPrintName}\n\n`, fontSize: 11 },
      {
        text: `Račun: ${invoiceDetails.documentNumber}/${invoiceDetails.storeTag}/${invoiceDetails.posTag}\n\n`,
        bold: true,
        fontSize: 18,
      },
      {
        table: {
          headerRows: 1,
          widths: ["50%", "*", "*", "auto", "*"],
          body: dataArrayPdf,
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === 0 || i === 1 || i === node.table.body.length ? 1 : 0.1;
          },
          vLineWidth: function (i, node) {
            return i === 0 || i === node.table.widths.length ? 1 : 0;
          },
          hLineColor: function (i, node) {
            return i === 0 || i === 1 || i === node.table.body.length
              ? "black"
              : "#f1f1f1";
          },
          vLineColor: function (i, node) {
            return i === 0 || i === node.table.widths.length
              ? "white"
              : "white";
          },
        },
      },

      {
        columns: [
          {
            text: "Ukupno :",
            marginTop: 15,
            marginBottom: 0,
            width: "*",
            bold: false,
            fontSize: 12,
          },
          {
            text: new Intl.NumberFormat("hr", {
              style: "currency",
              currency: activeCurrencyByDate(invoiceDetails.issued),
            }).format(Number(invoiceDetails.totalValue)),
            marginTop: 15,
            marginBottom: 0,
            width: "*",
            alignment: "right",
            bold: false,
            fontSize: 12,
          },
        ],
      },
      {
        columns: [
          {
            text: "Popust :",
            marginTop: 0,
            marginBottom: 0,
            width: "*",
            bold: false,
            fontSize: 12,
          },
          {
            text: new Intl.NumberFormat("hr", {
              style: "currency",
              currency: activeCurrencyByDate(invoiceDetails.issued),
            }).format(Number(invoiceDetails.discountValue)),
            marginTop: 0,
            marginBottom: 0,
            width: "*",
            alignment: "right",
            bold: false,
            fontSize: 12,
          },
        ],
      },
      {
        columns: [
          {
            text: "ZA PLATITI :",
            marginTop: 5,
            marginBottom: 5,
            width: "*",
            bold: true,
            fontSize: 15,
          },
          {
            text: new Intl.NumberFormat("hr", {
              style: "currency",
              currency: activeCurrencyByDate(invoiceDetails.issued),
            }).format(Number(invoiceDetails.payValue)),
            marginTop: 5,
            marginBottom: 0,
            width: "*",
            alignment: "right",
            bold: true,
            fontSize: 15,
          },
        ],
      },

      invoiceDetails.isTax ||
      invoiceDetailsTaxes.filter((e) => e.taxRateId === 4).length === 0
        ? `Rekapitulacija poreza \n`
        : "",
      invoiceDetails.inTax ||
      invoiceDetailsTaxes.filter((e) => e.taxRateId === 4).length === 0
        ? {
            table: {
              headerRows: 1,
              widths: [100, 100, 100],
              body: taxData,
            },
            layout: {
              hLineWidth: function (i, node) {
                return i === 0 || i === 1 || i === node.table.body.length
                  ? 1
                  : 0.1;
              },
              vLineWidth: function (i, node) {
                return i === 0 || i === node.table.widths.length ? 1 : 0;
              },
              hLineColor: function (i, node) {
                return i === 0 || i === 1 || i === node.table.body.length
                  ? "black"
                  : "f1f1f1";
              },
              vLineColor: function (i, node) {
                return i === 0 || i === node.table.widths.length
                  ? "white"
                  : "white";
              },
            },
          }
        : null,
      pn > 0
        ? {
            table: {
              headerRows: 1,
              widths: [100, 100, 100],
              body: [
                [
                  {
                    text: "Povratna naknada:",
                    fontSize: 10,
                    alignment: "left",
                  },
                  {
                    text: "",
                    fontSize: 10,
                    alignment: "left",
                  },
                  {
                    text: new Intl.NumberFormat("hr", {
                      style: "currency",
                      currency: activeCurrencyByDate(invoiceDetails.issued),
                    }).format(
                      Number(
                        invoiceDetailsItems.reduce(function (a, b) {
                          return Number(a) + Number(b.pn) * b.quantity;
                        }, 0)
                      )
                    ),
                    fontSize: 10,
                    alignment: "right",
                  },
                ],
              ],
            },
            layout: {
              hLineWidth: function (i, node) {
                return i === 0 || i === 1 || i === node.table.body.length
                  ? 0.5
                  : 0;
              },
              vLineWidth: function (i, node) {
                return i === 0 || i === node.table.widths.length ? 1 : 0;
              },
              hLineColor: function (i, node) {
                return i === 0 || i === node.table.body.length
                  ? "black"
                  : "white";
              },
              vLineColor: function (i, node) {
                return i === 0 || i === node.table.widths.length
                  ? "white"
                  : "white";
              },
            },
          }
        : null,
      {
        text:
          invoiceDetails.taxNote 
            ? `\n Porezna bilješka: ${invoiceDetails.taxNote} \n`
            : "",
        fontSize: 10,
        marginLeft: 5,
      },
      "",
      {
        text: invoiceDetails.description
          ? `\n ${invoiceDetails.description} \n`
          : "",
        fontSize: 10,
        marginLeft: 5,
      },

      " ",
       paymentId == 4 && year < 2026
        ? null
        : {
            image: base64QR,
            width: 60,
            marginLeft: 0,
            marginTop: 5,
            alignment: "right",
          },
      paymentId == 4 && year < 2026
        ? null
        : {
            text: `\nZKI: ${invoiceDetails.zki}\nJIR: ${invoiceDetails.jir}\n\n\n\n`,
            alignment: "right",
            fontSize: 10,
          },
      {
        text: `${invoiceDetails.footerNote}`,
        alignment: "center",
        fontSize: 11,
      },
    ],
    footer: function (currentPage, pageCount) {
      return {
        table: {
          widths: ["*"],
          body: [
            [
              {
                text:
                  `${translator("InvoiceCashBalancePDF-Page")} ` +
                  currentPage.toString() +
                  " / " +
                  pageCount,
                alignment: "right",
                style: "normalText",
                fontSize: 10,
                margin: [0, 20, 20, 0],
              },
            ],
          ],
        },
        layout: "noBorders",
      };
    },
  };

  const pdfDocGenerator = pdfMake.createPdf(dd);
  pdfDocGenerator.getBase64((data) => {
    partnerService
      .sendToMail(email, data, invoiceDetails.invoiceGuid)
      .then((res) => {});
    console.log(data);
  });
}



